(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var R = window.theme.routes;

  function money(cents) {
    var fmt = window.theme.moneyFormat || '{{amount}}';
    var n = (cents || 0) / 100;
    function d(v, p, t, s) { var x = v.toFixed(p).split('.'); x[0] = x[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return x[0] + (x[1] ? s + x[1] : ''); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return d(n, 0, ',', '.');
        case 'amount_with_comma_separator': return d(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return d(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return d(n, 2, "'", '.');
        default: return d(n, 2, ',', '.');
      }
    });
  }

  /* header height for sticky offsets */
  function setHeaderH() { var h = $('.section-header'); if (h) document.documentElement.style.setProperty('--header-h', h.offsetHeight + 'px'); }
  setHeaderH(); addEventListener('resize', setHeaderH);

  /* overlays: menu, search, cart */
  var lastFocus = null;
  function lock(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }
  function openOv(el) {
    lastFocus = document.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); lock(true);
    var f = el.querySelector('[data-autofocus]') || el.querySelector('input, a, button');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeOv(el) {
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    if (!$('.is-open')) lock(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { var t = $(o.getAttribute('data-open')); if (t) { e.preventDefault(); openOv(t); } return; }
    var c = e.target.closest('[data-close]');
    if (c) { var p = c.closest('.is-open'); if (p) { e.preventDefault(); closeOv(p); } }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('.is-open').forEach(closeOv); });

  /* cart */
  var Cart = {
    drawer: function () { return $('#CartDrawer'); },
    open: function () { var d = this.drawer(); if (d) openOv(d); else location.href = R.cart; },
    count: function (n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; }); },
    render: function (sections) {
      if (!sections || !sections['cart-drawer']) return;
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var n = doc.querySelector('#CartDrawerInner'), o = $('#CartDrawerInner');
      if (n && o) o.replaceWith(n);
    },
    sync: function () { return fetch(R.cart + '.js').then(function (r) { return r.json(); }).then(function (c) { Cart.count(c.item_count); }); },
    add: function (fd) {
      fd.append('sections', 'cart-drawer');
      fd.append('sections_url', location.pathname);
      return fetch(R.cartAdd + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
        .then(function (j) { Cart.render(j.sections); return Cart.sync(); })
        .then(function () { Cart.open(); });
    },
    change: function (line, qty) {
      return fetch(R.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty, sections: ['cart-drawer'], sections_url: location.pathname }) })
        .then(function (r) { return r.json(); })
        .then(function (j) { if (j.status) { alert(j.description || j.message); Cart.sync(); return; } Cart.render(j.sections); Cart.count(j.item_count); });
    }
  };
  window.AtelierCart = Cart;

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-ajax-cart]');
    if (!f || !Cart.drawer()) return;
    e.preventDefault();
    var btn = f.querySelector('[type=submit]'), err = f.querySelector('[data-error]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    if (err) err.hidden = true;
    Cart.add(new FormData(f))
      .catch(function (j) { var m = (j && (j.description || j.message)) || 'Could not add to cart. Please try again.'; if (err) { err.textContent = m; err.hidden = false; } else alert(m); })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    var l = b.closest('.line'); if (l) l.setAttribute('aria-busy', 'true');
    Cart.change(parseInt(b.getAttribute('data-line'), 10), parseInt(b.getAttribute('data-qty'), 10));
  });

  /* quantity steppers */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var input = b.parentNode.querySelector('input'); if (!input) return;
    var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10));
    input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* product page */
  $$('[data-product]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-product-json]'); if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var inv = {}; try { inv = JSON.parse(root.querySelector('[data-inventory]').textContent); } catch (e) {}
    var form = root.querySelector('form[data-ajax-cart]');
    var idInput = root.querySelector('[data-variant-id]');
    var fieldsets = $$('[data-opt]', root);
    var stock = root.querySelector('[data-stock]');
    var bar = root.querySelector('[data-sticky-atc]');

    function vals() { return fieldsets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; }); }
    function find(v) { return data.variants.find(function (x) { return x.options.every(function (o, i) { return o === v[i]; }); }); }
    function showMedia(id) {
      var s = root.querySelector('[data-slide="' + id + '"]'); if (!s) return;
      $$('[data-slide]', root).forEach(function (x) { x.classList.toggle('is-active', x === s); });
      $$('[data-thumb]', root).forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-thumb') === String(id) ? 'true' : 'false'); });
    }
    root.addEventListener('click', function (e) { var t = e.target.closest('[data-thumb]'); if (t) showMedia(t.getAttribute('data-thumb')); });

    function priceHTML(v) { return '<span>' + money(v.price) + '</span>' + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : ''); }
    function update(push) {
      var cur = vals(), v = find(cur);
      fieldsets.forEach(function (fs, i) {
        var lab = fs.querySelector('[data-opt-value]'); if (lab) lab.textContent = cur[i] || '';
        $$('input', fs).forEach(function (inp) {
          var t = cur.slice(); t[i] = inp.value; var tv = find(t);
          inp.classList.toggle('is-unavailable', !tv || !tv.available);
          var sub = inp.parentNode.querySelector('[data-opt-price]');
          if (sub) sub.textContent = tv ? (tv.available ? money(tv.price) : 'Sold out') : 'Unavailable';
        });
      });
      var btns = $$('[data-atc]', root);
      if (!v) { btns.forEach(function (b) { b.disabled = true; var l = b.querySelector('[data-atc-label]'); if (l) l.textContent = 'Unavailable'; }); return; }
      idInput.value = v.id;
      btns.forEach(function (b) { b.disabled = !v.available; var l = b.querySelector('[data-atc-label]'); if (l) l.textContent = v.available ? 'Add to cart' : 'Sold out'; });
      $$('[data-atc-price]', root).forEach(function (el) { el.textContent = money(v.price); });
      $$('[data-price]', root).forEach(function (el) { el.innerHTML = priceHTML(v); });
      $$('[data-variant-title]', root).forEach(function (el) { el.textContent = v.title; });
      if (stock) {
        var q = inv[v.id];
        var low = window.theme.lowStock || 0;
        if (v.available && q != null && q > 0 && q <= low) { stock.textContent = 'Only ' + q + ' left in ' + v.title + ' \u2014 printed in small batches'; stock.hidden = false; }
        else stock.hidden = true;
      }
      if (v.featured_media) showMedia(v.featured_media.id);
      if (push) history.replaceState(null, '', location.pathname + '?variant=' + v.id);
    }
    root.addEventListener('change', function (e) { if (e.target.closest('[data-opt]')) update(true); });
    if (fieldsets.length) update(false);

    var buy = root.querySelector('[data-buy]');
    if (buy && bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var e = es[0], show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(buy);
      var sb = bar.querySelector('[data-sticky-btn]');
      if (sb) sb.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
    }
  });

  /* product recommendations */
  $$('[data-recs]').forEach(function (el) {
    var url = el.getAttribute('data-url'); if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (h) {
      var d = new DOMParser().parseFromString(h, 'text/html').querySelector('[data-recs]');
      if (d && d.innerHTML.trim()) { el.innerHTML = d.innerHTML; reveal(el); } else el.remove();
    });
  });

  /* predictive search */
  var si = $('#SearchInput'), out = $('#PredictiveResults');
  if (si && out) {
    var timer, ctrl;
    si.addEventListener('input', function () {
      clearTimeout(timer);
      var q = si.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort(); ctrl = 'AbortController' in window ? new AbortController() : null;
        fetch(R.search + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][fields]=title,vendor,product_type,variants.title&section_id=predictive-search', ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.text(); })
          .then(function (h) { var n = new DOMParser().parseFromString(h, 'text/html').querySelector('#PredictiveInner'); out.innerHTML = n ? n.innerHTML : ''; })
          .catch(function () {});
      }, 220);
    });
  }

  /* collection filters */
  $$('form[data-facets]').forEach(function (f) {
    f.addEventListener('change', function () {
      $$('input, select', f).forEach(function (i) { if (i.type !== 'checkbox' && !i.value) i.disabled = true; });
      f.submit();
    });
  });
  document.addEventListener('click', function (e) {
    $$('details.filter[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* collection hover list */
  function chlSet(item) {
    var root = item.closest('[data-chl]'); if (!root) return;
    var i = item.getAttribute('data-chl-item');
    $$('[data-chl-item]', root).forEach(function (el) { el.classList.toggle('is-active', el === item); });
    $$('[data-chl-img]', root).forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-chl-img') === i); });
  }
  document.addEventListener('mouseover', function (e) { var it = e.target.closest && e.target.closest('[data-chl-item]'); if (it && !it.classList.contains('is-active')) chlSet(it); });
  document.addEventListener('focusin', function (e) { var it = e.target.closest && e.target.closest('[data-chl-item]'); if (it) chlSet(it); });


  /* product carousel */
  function initCarousels(scope) {
    $$('[data-carousel]', scope).forEach(function (root) {
      if (root._car) return; root._car = true;
      var track = root.querySelector('[data-carousel-track]'), prev = root.querySelector('[data-carousel-prev]'), next = root.querySelector('[data-carousel-next]'), bar = root.querySelector('[data-carousel-bar]');
      if (!track) return;
      function sync() {
        var max = track.scrollWidth - track.clientWidth, r = max > 0 ? track.scrollLeft / max : 1;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
        if (bar) bar.style.width = Math.max(8, r * 100) + '%';
      }
      function go(d) { track.scrollBy({ left: d * track.clientWidth * 0.8, behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', sync, { passive: true });
      track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); } });
      addEventListener('resize', sync); sync();
    });
  }
  initCarousels(document);
  document.addEventListener('shopify:section:load', function (e) { initCarousels(e.target); });

  /* reveal on scroll */
  var io = null;
  if (document.documentElement.classList.contains('reveal-on')) {
    io = new IntersectionObserver(function (es) {
      var i = 0;
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.style.transitionDelay = Math.min(i++ * 80, 400) + 'ms';
        e.target.classList.add('is-in'); io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px' });
  }
  function reveal(scope) { if (io) $$('[data-reveal]:not(.is-in)', scope).forEach(function (el) { io.observe(el); }); }
  reveal(document);
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); setHeaderH(); });
})();
